export const getAverageScore = (scores: Array<number | null>) => {
  const validScores = scores.filter((score): score is number => typeof score === 'number' && Number.isFinite(score));

  if (!validScores.length) {
    return null;
  }

  return validScores.reduce((total, score) => total + score, 0) / validScores.length;
};
